module.exports = __webpack_public_path__ + "media/images/team/markus1-f3d33099ea0b09d2b8aab9975b14fc36.jpg";